module.exports = __webpack_public_path__ + "media/images/admin/icons/scissors-37b72d07d22341b6cd06514784549a7b.svg";